/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import ModalContent from './Partials/ModalContent';

import sizeChartStyles from './Partials/AllSizeChartStyles';

const styles = (theme) => ({
    closeIconWrapper: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});
/* eslint-disable react/jsx-props-no-spreading */
const DialogTitle = withStyles(styles)((props) => {
    const {
        children, classes, onClose, ...other
    } = props;
    return (
        <MuiDialogTitle disableTypography className={`${classes.closeIconWrapper} size-chart-modal-header`} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

const SizeChartModal = withStyles(styles)(({ sizeChartToggle, isOpen, showAllPlantersSizeChart }) => {
    const styless = sizeChartStyles();
    return (
        <Dialog className={styless.sizeChartModal} fullWidth maxWidth="md" onClose={sizeChartToggle} aria-labelledby="customized-dialog-title" open={isOpen}>
            <DialogTitle id="customized-dialog-title" onClose={sizeChartToggle} />
            <DialogContent>
                <ModalContent showAllPlantersSizeChart={showAllPlantersSizeChart} />
            </DialogContent>
        </Dialog>
    );
});

export default SizeChartModal;
